export default __webpack_public_path__ + "1422354fa43038081dd59bd9a773cd2e.gif";